<div class="filter">
  <wb-icon slot="icon" name="bds/filter/24"></wb-icon>
  <wb-text>{{ 'FILTER' | translate }}</wb-text>
  <wb-counter value="{{ filteredTags[this.activeEntity].length }}" variant="primary"></wb-counter>
  @for (tagMenu of activeTagMenus; track tagMenu.id) {
    @if (isMultiSelectAvailable(tagMenu.children!)) {
      <wb-multi-select
        [attr.disabled]="isMultiSelectDisabled(tagMenu.children!) ? true : null"
        (wbchange)="filterTags($event, tagMenu.children!)"
        theme="dark"
        label="{{ tagMenu.name[this.currentLanguage] }}"
      >
        @for (tag of tagMenu.children; track tag.id) {
          @if (isTagAvailable(tag.id)) {
            <wb-checkbox
              theme="dark"
              name="{{ tag.name[this.currentLanguage] }}"
              value="{{ tag.id }}"
              [disabled]="isTagDisabled(tag.id)"
              [checked]="isChecked(tag.id)"
              >{{ tag.name[this.currentLanguage] }}</wb-checkbox
            >
          }
        }
      </wb-multi-select>
    }
  }
  <wb-button (click)="allFilters()" variant="tertiary" theme="dark">
    <wb-icon slot="icon" name="bds/arrow-right/24"></wb-icon>
    {{ 'ALL_FILTERS' | translate }}
  </wb-button>
</div>
<wb-accordion prevent-mobile-flyout theme="dark">
  <wb-accordion-item>
    <span slot="header">
      <wb-icon slot="icon" name="bds/filter/24"></wb-icon>
      <wb-text>{{ 'FILTER' | translate }}</wb-text>
      <wb-counter value="{{ filteredTags[this.activeEntity].length }}" variant="primary"></wb-counter>
    </span>
    <span slot="mobile-header">{{ 'CLOSE' | translate }}</span>
    <div slot="content">
      @for (tagMenu of activeTagMenus; track tagMenu.id) {
        @if (isMultiSelectAvailable(tagMenu.children!)) {
          <mb-wb-multi-select
            [attr.disabled]="isMultiSelectDisabled(tagMenu.children!) ? true : null"
            theme="dark"
            label="{{ tagMenu.name[this.currentLanguage] }}"
            [checkboxCount]="getCheckboxCount(tagMenu.id)"
            (resetTagMenuEvent)="resetTagMenu(tagMenu.id)"
          >
            @for (tag of tagMenu.children; track tag.id) {
              @if (isTagAvailable(tag.id)) {
                <wb-checkbox
                  theme="dark"
                  name="{{ tag.name[this.currentLanguage] }}"
                  value="{{ tag.name[this.currentLanguage] }}"
                  [disabled]="isTagDisabled(tag.id)"
                  [checked]="isChecked(tag.id)"
                  (wbchange)="filterTag($event, tag)"
                  >{{ tag.name[this.currentLanguage] }}</wb-checkbox
                >
              }
            }
          </mb-wb-multi-select>
        }
      }
      <wb-button variant="tertiary" theme="dark">
        <wb-icon slot="icon" name="bds/arrow-right/24"></wb-icon>
        {{ 'ALL_FILTERS' | translate }}
      </wb-button>
    </div>
  </wb-accordion-item>
</wb-accordion>
@if (filteredTags[this.activeEntity].length) {
  <div class="tags">
    @for (tag of filteredTags[this.activeEntity]; track tag.id) {
      <wb-interactive-tag variant="button" size="m" theme="dark" (wbremove)="removeTag(tag)"
        ><div class="tag-text-wrapper">
          <wb-text size="m" static strong ellipsis>{{ tag.name[this.currentLanguage] }}</wb-text>
        </div></wb-interactive-tag
      >
    }
    <wb-button (click)="reset()" variant="tertiary" size="s" theme="dark">
      <wb-icon slot="icon" name="bds/reset/24"></wb-icon>
      {{ 'RESET_ALL' | translate }}
    </wb-button>
  </div>
}
